import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirFormRegenService {

  constructor(private http: HttpClient) { }

  getFilingGroups(baseUrl: string, taxYear: any, scenario: any, jcdKey: any): Observable<any> {
    let params = new HttpParams();
    params = params.set('action_code', 'gk7crv');
    if (taxYear !== undefined && taxYear !== null && taxYear !== '') {
      params = params.set('tax_year', String(taxYear));
    }
    if (scenario !== undefined && scenario !== null && scenario !== '') {
      params = params.set('scenario', String(scenario));
    }
    if (jcdKey !== undefined && jcdKey !== null && jcdKey !== '') {
      params = params.set('jcd_key', String(jcdKey));
    }
    return this.http.get<any>(`${baseUrl}/loadJsonObject`, { params, withCredentials: true });
  }

  // Mirrors legacy TriggerFIRFormRegenService.triggerFormGeneration
  // action_code=ppjh1p with clob_data, clob_settings, process_name, globalParams, filterParams
  triggerFormGeneration(
    baseUrl: string,
    clobSettings: any,
    clobData: any[],
    globalParams: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=ppjh1p`;

    // Build params matching legacy: merge filterParams + globalParams + clob fields
    // Legacy order: filterParams first, then globalParams overlay, then specific fields
    const merged: any = {
      ...filterParams,
      ...globalParams,
      combination_key: clobSettings.combination_key,
      sso_id: clobSettings.sso_id,
      clob_data: JSON.stringify(clobData),
      clob_settings: JSON.stringify(clobSettings),
      process_name: 'TRIGGER_FORM_REGEN_' + (clobSettings.irs_form_no || '')
    };

    // Send as x-www-form-urlencoded (matching legacy AngularJS $http with form-encode interceptor)
    const body = new URLSearchParams();
    Object.keys(merged).forEach(key => {
      const val = merged[key];
      if (val !== undefined && val !== null) {
        body.set(key, typeof val === 'object' ? JSON.stringify(val) : String(val));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
} 
